import { Heading } from '@chakra-ui/react';

import { Card } from './card';
import { Glyph } from './glyph';

type GlyphCardProps = {
  title: string;
  glyphName: string;
};

export function GlyphCard({ title, glyphName }: GlyphCardProps) {
  return (
    <Card
      alignItems='center'
      borderRadius='8px'
      boxShadow='md'
      display='flex'
      flexDir='row'
      gap='24px'
      position='relative'
      px={6}
      py={8}
      w={{ base: 'full', md: '544px' }}
    >
      {glyphName && <Glyph height={64} name={glyphName} style={{ flexShrink: 0 }} width={64} />}
      <Heading as='h3' fontSize='20px' fontWeight='400' lineHeight='28px'>
        {title ?? title}
      </Heading>
    </Card>
  );
}
